import { createSelector } from "reselect";
import { selectHasPrepV2, selectIsPrepJobArchived } from ".";

export const selectShouldShowPrepShipmentDetail = createSelector(
  selectIsPrepJobArchived,
  selectHasPrepV2,
  (isPrepJobArchived, hasPrepV2): boolean => {
    return hasPrepV2 && !isPrepJobArchived;
  }
);
